import feathers from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';

import store from '../../store/';

const feathersClient = feathers().configure(
  rest('/admin')
    .fetch(window.fetch))
    .hooks({
      before: {
        all: [
          context => {
            const authenticationToken = store.state.admin.authenticationToken;
            if (authenticationToken) {
              context.params.headers = { ['Authorization']: `Bearer ${authenticationToken}`, };
            }

            return context;
          },
        ],
      },

      error: {
        all: [
          context => {
            if (context.service.name !== 'authentication' && context.error && context.error.code === 401) {
              store.dispatch('admin/logout');
            }

            return context;
          },
        ],
      },
    }
  );

export default feathersClient;
